export default {"src":"/_next/static/media/icn-arrow-right.17b93315.svg","height":24,"width":24};